var _path, _path2, _rect, _rect2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddScheduleOtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2V3.5",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5.5,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "#002A69"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 5.5,
    width: 2,
    height: 6,
    rx: 0.4,
    fill: "#002A69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2041 3.01074C13.2128 3.113 14 3.96435 14 5V9.88281C13.7349 9.64477 13.3845 9.5 13 9.5V5C13 4.44772 12.5523 4 12 4H4C3.44772 4 3 4.44772 3 5V12C3 12.5523 3.44772 13 4 13H10.8838C11.0649 13.2015 11.2993 13.3541 11.5654 13.4346C11.6297 13.647 11.7405 13.8388 11.8848 14H4C2.96435 14 2.113 13.2128 2.01074 12.2041L2 12V5C2 3.89543 2.89543 3 4 3H12L12.2041 3.01074Z",
    fill: "#002A69"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 5.5C11.8205 5.5 12 5.67948 12 5.90039V9.88281C11.7983 10.0639 11.646 10.2991 11.5654 10.5654C11.1089 10.7035 10.7454 11.0531 10.5869 11.5H10.4004C10.1795 11.5 10 11.3205 10 11.0996V5.90039C10 5.67948 10.1795 5.5 10.4004 5.5H11.5996Z",
    fill: "#002A69"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12H14M13 11V13",
    stroke: "#002A69",
    strokeWidth: 1.14,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddScheduleOtl);
export default __webpack_public_path__ + "static/media/Add_schedule_otl.8f54dc4c32501b8571385d7ede1e51f3.svg";
export { ForwardRef as ReactComponent };